export const translations = {
  en: {
    // Navigation
    home: 'Home',
    cars: 'Fleet',
    destinations: 'Destinations',
    bookRide: 'Book a Ride',
    reviews: 'Reviews',
    paymentInfo: 'Payment',
    contactUs: 'Contact',
    login: 'Login',
    logout: 'Logout',
    admin: 'Dashboard',

    // Hero Section
    heroSubtitle: 'Premium Transportation',
    heroTitle: 'Luxury Limousine Service',
    heroDescription: 'Experience unparalleled comfort and elegance with our premium fleet. Professional chauffeurs, impeccable service, unforgettable journeys.',
    bookNow: 'Book Now',
    exploreFleet: 'Explore Fleet',

    // Features
    featuresTitle: 'Why Choose Us',
    featuresSubtitle: 'Excellence in Every Journey',
    feature1Title: 'Premium Fleet',
    feature1Desc: 'Luxury vehicles maintained to the highest standards',
    feature2Title: 'Professional Chauffeurs',
    feature2Desc: 'Experienced, courteous, and multilingual drivers',
    feature3Title: '24/7 Service',
    feature3Desc: 'Available around the clock for your convenience',
    feature4Title: 'Safety First',
    feature4Desc: 'Licensed, insured, and regularly inspected vehicles',

    // Cars Section
    viewCars: 'Our Fleet',
    carsSubtitle: 'Premium Vehicles',
    capacity: 'Capacity',
    passengers: 'passengers',
    luggage: 'Luggage',
    bags: 'bags',
    book: 'Reserve',
    type: 'Type',
    viewAll: 'View All Vehicles',

    // Destinations
    popularDestinations: 'Popular Destinations',
    destinationsSubtitle: 'Explore Egypt',
    distance: 'Distance',
    startingFrom: 'Starting from',

    // Reviews
    customerReviews: 'Client Testimonials',
    reviewsSubtitle: 'What Our Clients Say',
    addReview: 'Share Your Experience',
    name: 'Full Name',
    rating: 'Rating',
    comment: 'Your Review',
    submit: 'Submit',

    // Booking Form
    bookingType: 'Service Type',
    fromAirport: 'Airport Pickup',
    toAirport: 'Airport Drop-off',
    insideCairo: 'City Transfer',
    anywhere: 'Custom Route',
    tripType: 'Trip Type',
    oneWay: 'One Way',
    roundTrip: 'Round Trip',
    pickupLocation: 'Pickup Location',
    dropoffLocation: 'Drop-off Location',
    date: 'Date',
    time: 'Time',
    returnDate: 'Return Date',
    returnTime: 'Return Time',
    carType: 'Vehicle Type',
    fullName: 'Full Name',
    mobile: 'Mobile Number',
    whatsapp: 'WhatsApp Number',
    notes: 'Special Requests',

    // Payment
    paymentMethods: 'Payment Methods',
    bankTransfer: 'Bank Transfer',
    mobileWallet: 'Mobile Wallet',
    instapay: 'InstaPay',
    uploadProof: 'Upload Payment Proof',
    totalCost: 'Amount',

    // Contact
    getInTouch: 'Get in Touch',
    contactSubtitle: 'We\'re Here to Help',
    subject: 'Subject',
    message: 'Message',
    send: 'Send Message',
    address: 'Address',
    email: 'Email',
    phone: 'Phone',

    // Status
    status: 'Status',
    pending: 'Pending',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    completed: 'Completed',
    verified: 'Verified',
    paid: 'Paid',
    unpaid: 'Unpaid',

    // Admin
    dashboard: 'Dashboard',
    totalBookings: 'Total Bookings',
    totalCars: 'Total Vehicles',
    totalDrivers: 'Total Drivers',
    availableCars: 'Available Vehicles',
    availableDrivers: 'Available Drivers',
    unreadMessages: 'Unread Messages',
    pendingPayments: 'Pending Payments',

    // Common
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    price: 'Price',
    unauthorizedAccess: 'Unauthorized Access',
    unauthorizedMessage: 'You do not have permission to access the admin dashboard. Redirecting to home page...',
    profile: 'Profile',
    myAccount: 'My Account',
    myBookings: 'My Bookings',
    myReviews: 'My Reviews',
    accountInfo: 'Account Information',
    updateProfile: 'Update Profile',
    noBookings: 'No bookings yet',
    noReviews: 'No reviews yet',

    // Footer
    footerTagline: 'Premium limousine service across Egypt. Experience luxury, comfort, and reliability.',
    quickLinks: 'Quick Links',
    services: 'Services',
    followUs: 'Follow Us',
    allRights: 'All Rights Reserved',

    // CTA
    ctaTitle: 'Ready for Your Journey?',
    ctaDescription: 'Book your premium transportation today and experience the difference.',

    // Image Types
    imageTypeCar: 'Car Image',
    imageTypeDriverLicense: 'Driver License',
    imageTypeBookingPaymentProof: 'Booking Payment Proof',
    imageTypePaymentProof: 'Payment Proof',
    imageTypeDestination: 'Destination Image',
    imageLocation: 'Location',
    imageDescription: 'Description',
  },

  ar: {
    // Navigation
    home: 'الرئيسية',
    cars: 'الأسطول',
    destinations: 'الوجهات',
    bookRide: 'احجز رحلة',
    reviews: 'التقييمات',
    paymentInfo: 'الدفع',
    contactUs: 'تواصل معنا',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    admin: 'لوحة التحكم',

    // Hero Section
    heroSubtitle: 'خدمة نقل فاخرة',
    heroTitle: 'خدمة ليموزين فاخرة',
    heroDescription: 'استمتع براحة وأناقة لا مثيل لها مع أسطولنا الفاخر. سائقون محترفون، خدمة متميزة، رحلات لا تُنسى.',
    bookNow: 'احجز الآن',
    exploreFleet: 'استكشف الأسطول',

    // Features
    featuresTitle: 'لماذا تختارنا',
    featuresSubtitle: 'التميز في كل رحلة',
    feature1Title: 'أسطول فاخر',
    feature1Desc: 'سيارات فاخرة يتم صيانتها وفق أعلى المعايير',
    feature2Title: 'سائقون محترفون',
    feature2Desc: 'سائقون ذوو خبرة، مهذبون، ويتحدثون عدة لغات',
    feature3Title: 'خدمة على مدار الساعة',
    feature3Desc: 'متاحون على مدار الساعة لراحتك',
    feature4Title: 'السلامة أولاً',
    feature4Desc: 'سيارات مرخصة ومؤمنة ويتم فحصها بانتظام',

    // Cars Section
    viewCars: 'أسطولنا',
    carsSubtitle: 'سيارات فاخرة',
    capacity: 'السعة',
    passengers: 'ركاب',
    luggage: 'الأمتعة',
    bags: 'حقائب',
    book: 'احجز',
    type: 'النوع',
    viewAll: 'عرض جميع السيارات',

    // Destinations
    popularDestinations: 'الوجهات الشائعة',
    destinationsSubtitle: 'استكشف مصر',
    distance: 'المسافة',
    startingFrom: 'تبدأ من',

    // Reviews
    customerReviews: 'آراء العملاء',
    reviewsSubtitle: 'ماذا يقول عملاؤنا',
    addReview: 'شارك تجربتك',
    name: 'الاسم الكامل',
    rating: 'التقييم',
    comment: 'تعليقك',
    submit: 'إرسال',

    // Booking Form
    bookingType: 'نوع الخدمة',
    fromAirport: 'استقبال من المطار',
    toAirport: 'توصيل للمطار',
    insideCairo: 'تنقل داخل المدينة',
    anywhere: 'مسار مخصص',
    tripType: 'نوع الرحلة',
    oneWay: 'ذهاب فقط',
    roundTrip: 'ذهاب وعودة',
    pickupLocation: 'موقع الاستلام',
    dropoffLocation: 'موقع الوصول',
    date: 'التاريخ',
    time: 'الوقت',
    returnDate: 'تاريخ العودة',
    returnTime: 'وقت العودة',
    carType: 'نوع السيارة',
    fullName: 'الاسم الكامل',
    mobile: 'رقم الجوال',
    whatsapp: 'رقم الواتساب',
    notes: 'طلبات خاصة',

    // Payment
    paymentMethods: 'طرق الدفع',
    bankTransfer: 'تحويل بنكي',
    mobileWallet: 'محفظة إلكترونية',
    instapay: 'إنستاباي',
    uploadProof: 'رفع إثبات الدفع',
    totalCost: 'المبلغ',

    // Contact
    getInTouch: 'تواصل معنا',
    contactSubtitle: 'نحن هنا لمساعدتك',
    subject: 'الموضوع',
    message: 'الرسالة',
    send: 'إرسال الرسالة',
    address: 'العنوان',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',

    // Status
    status: 'الحالة',
    pending: 'قيد الانتظار',
    confirmed: 'مؤكد',
    cancelled: 'ملغي',
    completed: 'مكتمل',
    verified: 'تم التحقق',
    paid: 'مدفوع',
    unpaid: 'غير مدفوع',

    // Admin
    dashboard: 'لوحة التحكم',
    totalBookings: 'إجمالي الحجوزات',
    totalCars: 'إجمالي السيارات',
    totalDrivers: 'إجمالي السائقين',
    availableCars: 'السيارات المتاحة',
    availableDrivers: 'السائقون المتاحون',
    unreadMessages: 'الرسائل غير المقروءة',
    pendingPayments: 'المدفوعات المعلقة',

    // Common
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    success: 'نجاح',
    cancel: 'إلغاء',
    save: 'حفظ',
    edit: 'تعديل',
    delete: 'حذف',
    view: 'عرض',
    price: 'السعر',
    unauthorizedAccess: 'وصول غير مصرح',
    unauthorizedMessage: 'ليس لديك صلاحية للوصول إلى لوحة التحكم. سيتم إعادة التوجيه إلى الصفحة الرئيسية...',
    profile: 'الملف الشخصي',
    myAccount: 'حسابي',
    myBookings: 'حجوزاتي',
    myReviews: 'تقييماتي',
    accountInfo: 'معلومات الحساب',
    updateProfile: 'تحديث الملف الشخصي',
    noBookings: 'لا توجد حجوزات بعد',
    noReviews: 'لا توجد تقييمات بعد',

    // Footer
    footerTagline: 'خدمة ليموزين فاخرة في جميع أنحاء مصر. استمتع بالفخامة والراحة والموثوقية.',
    quickLinks: 'روابط سريعة',
    services: 'الخدمات',
    followUs: 'تابعنا',
    allRights: 'جميع الحقوق محفوظة',

    // CTA
    ctaTitle: 'هل أنت مستعد لرحلتك؟',
    ctaDescription: 'احجز وسيلة نقلك الفاخرة اليوم واستمتع بالفرق.',

    // Image Types
    imageTypeCar: 'صورة سيارة',
    imageTypeDriverLicense: 'رخصة سائق',
    imageTypeBookingPaymentProof: 'إثبات دفع حجز',
    imageTypePaymentProof: 'إثبات دفع',
    imageTypeDestination: 'صورة وجهة',
    imageLocation: 'الموقع',
    imageDescription: 'الوصف',
  }
};